<template>
    <div class="reset-chat-session-prompt slide-up">
        <div class="reset-chat-session-prompt__container">
            <p class="reset-chat-session-prompt__text" v-html="$t('Chatbot.reset_chat_session_text')"></p>
            <div class="reset-chat-session-prompt__buttons">
                <TotemButton
                    class="reset-chat-session-prompt__reset-button"
                    size="medium"
                    color="primary"
                    @click="openNewChatSession"
                    icon="checkmark"
                    :label="$t('General.yes')"
                />
                <TotemButton
                    class="reset-chat-session-prompt__cancel-button"
                    size="medium"
                    color="primary"
                    @click="cancelChatSession"
                    icon="cancel"
                    :label="$t('General.no')"
                />
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ResetChatSessionPrompt',
        methods: {
            openNewChatSession () {
                this.$emit('open-new-chat-session')
            },
            cancelChatSession () {
                this.$emit('cancel-chat-session')
            }
        }
    }
</script>

<style lang="scss">
    .reset-chat-session-prompt {
        display: flex;
        flex-direction: column;
        position: absolute;
        width: 100%;
        z-index: 1000;
        background: $bright_gray;
        margin: 0;
        border-bottom: solid 1px $silver_chalice;

        &__container {
            padding: 30px 25px;
        }

        &__text {
            font-size: 1.6rem;
            margin-bottom: 20px;
            margin: 0 auto;
            text-align: center;
        }

        &__buttons {
            display: flex;
            display: flex;
            margin: 20px 25px 0px 25px;
            justify-content: space-evenly;
            flex-direction: row;
        }

        &__reset-button {
            color: $black !important;
            background: $fringy_flower !important;
            &:hover {
                background: $summer_green !important;
            }
        }

        &__cancel-button {
            color: $black !important;
            background: $azalea !important;
            &:hover {
                background: $rose_fog !important;
            }
        }
    }

    .slide-up, .slide-down {
        overflow:hidden
    }
    .slide-up > div, .slide-down > div {
        margin-top: -41%;
        transition: margin-top 0.4s ease-in-out;
    }
    .slide-down > div {
        margin-top: 55px;
    }
</style>
